"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Icons = __importStar(require("./Icons"));
function Icon({ className = '', iconName, iconStyles, onMouseEnter, onMouseLeave }) {
    if (!iconName || !Icons[iconName]) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: Icons[iconName]({
            // The child will inherit color, width and height from the parent span
            className: (0, classnames_1.default)('fill-[currentColor]', 'w-[inherit]', 'h-[inherit]'),
            iconStyles
        }) })));
}
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map